import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
//import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm text-gray-800`;
const Text = styled.div`
  ${tw`text-lg  p-10 text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
          <Text>
            {/* <p>Elektroniczne etykiety cenowe (ESL) w biurowcach to innowacyjne rozwiązanie, które wychodzi poza tradycyjny kontekst handlowy, znajdując zastosowanie w nowoczesnych przestrzeniach biurowych. Chociaż systemy ESL są najczęściej kojarzone z branżą detaliczną, to w inteligentnych biurach ich implementacja może przynieść szereg korzyści, zarówno z perspektywy zarządzania przestrzenią, jak i optymalizacji procesów.</p> */}

            <h2>5 przykładowych zastosowań e-cenówek w biurowcu:</h2>
            <h3>
            1. Cenniki i informacje o usługach biurowych.<br></br> 
            </h3>
            <p>
            W biurach, zwłaszcza tych działających na zasadzie coworkingów, wynajmu przestrzeni lub w firmach oferujących usługi wewnętrzne, takich jak sale konferencyjne, drukowanie, czy wynajem sprzętu, elektroniczne etykiety cenowe mogą być wykorzystywane do wyświetlania cen za poszczególne usługi. Dzięki integracji z systemem zarządzania biurem, takie etykiety mogą dynamicznie aktualizować ceny w zależności od dostępności lub promocji.
            </p>
            <h3>
            2. Zarządzanie dostępnością przestrzeni.
            </h3>
            <p>W inteligentnych biurach przestrzenie robocze, takie jak pokoje konferencyjne, sale spotkań czy biurka, mogą być wyposażone w e-cenówki, które wyświetlają informacje o dostępności danego miejsca. Dzięki zintegrowanym czujnikom, które monitorują, czy przestrzeń jest zajęta, etykiety mogą automatycznie zmieniać kolor lub komunikować dostępność sali w czasie rzeczywistym. To sprawia, że użytkownicy łatwo mogą zaplanować spotkania i korzystać z przestrzeni biurowych bez zbędnych komplikacji.</p>
            <h3>
            3. Prezentacja dynamicznych informacji o wydarzeniach.
            </h3>
            <p>W nowoczesnych biurach odbywają się często spotkania, prezentacje, czy szkolenia. Etykiety cenowe mogą być wykorzystywane do wyświetlania aktualnych informacji o wydarzeniach na poziomie sal konferencyjnych czy przestrzeni wspólnych. W ten sposób mogą wyświetlać dane takie jak godzina rozpoczęcia spotkania, tematyka, organizatorzy czy dostępność przestrzeni.</p>
            <h3>
            4. Zarządzanie produktami biurowymi i zapasami.
            </h3>
            <p>Etykiety ESL mogą również zostać wykorzystane do zarządzania zapasami biurowymi (np. papier, tonery, długopisy) w przestrzeniach wspólnych. Etykiety mogą wyświetlać dostępność materiałów lub przypomnienia o konieczności ich uzupełnienia, co usprawnia procesy logistyczne w biurze.</p>
            <h3>
            5. Prezentacja lokalnych usług i ofert.
            </h3>
            <p>Elektroniczne etykiety mogą również informować pracowników biura o dostępnych usługach w danym budynku, takich jak oferta kantyny, usługi cateringowe, serwis sprzątający, czy dostępność usług wellness. Tego rodzaju informacje mogą być wyświetlane na ekranach w holu, windach, czy przy wejściu do pomieszczeń, co zwiększa wygodę i oszczędza czas pracowników.</p>
          </Text>

      <MainFeature1
        subheading={<Subheading>Województwo mazowieckie</Subheading>}
        heading="Biuro Plantowa 5"
        description = "Nadarzyn ul. Plantowa 5"
        buttonRounded={false}
        primaryButtonText="brak filmu >>"
        primaryButtonUrl = "#"
        imageSrc="IMG_0389.jpg"
        textOnLeft={false}
      />
      {/* <MainFeature1
        // subheading={<Subheading>KROK 2 - wykonanie aplikacji</Subheading>}
        heading=""
        description = ""
        // buttonRounded={false}
        primaryButtonText=""
        primaryButtonUrl = ""
        imageSrc=""
      /> */}
      {/* <MainFeature1
        subheading={<Subheading>KROK 3 - utrzymanie i serwis</Subheading>}
        heading="Jesteśmy tutaj aby pomagać."
        description ="Dokładamy wszelkich starań, aby nasze aplikacje działały bez zarzutu. Jeśli potrzebujesz zaktualizwoać swoje dane lub potrzebujesz porady dotyczącej Twojej eWizytówki skontaktuj się z naszym ekspertem."
        // buttonRounded={false}
        primaryButtonText="Serwis 24/7"
        primaryButtonUrl = "/serwis"
        imageSrc = "./serwis.jpg"
        textOnLeft={false}
      /> */}
      {/* <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
        ]}
        linkText=""
      />
      <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
};
